import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: "How much debt can you settle?",
    answer: "We can typically settle debts for 40-60% of what you owe. Our licensed specialists negotiate directly with creditors to reduce your total debt amount. The exact settlement depends on your specific situation, creditor policies, and debt type. We've successfully settled over $500 million in debt for our clients."
  },
  {
    question: "How long does debt settlement take?",
    answer: "Most debt settlement programs take 24-48 months to complete. However, some clients see their first settlements within 3-6 months. The timeline depends on your total debt amount, monthly payment capacity, and how quickly we can negotiate with your creditors."
  },
  {
    question: "Will debt settlement hurt my credit score?",
    answer: "Debt settlement may temporarily impact your credit score, but it's often better than bankruptcy or continued missed payments. Once debts are settled and you rebuild your finances, most clients see their credit scores improve significantly within 12-24 months. We provide credit rebuilding guidance throughout the process."
  },
  {
    question: "Do you charge upfront fees?",
    answer: "No, we never charge upfront fees. You only pay when we successfully settle a debt for you. Our fees are based on the amount of debt we settle, and we're completely transparent about all costs. There are no hidden fees or surprises."
  },
  {
    question: "What types of debt can you settle?",
    answer: "We settle credit card debt, personal loans, medical bills, business debt, merchant cash advance loans, and other unsecured debts. We cannot settle secured debts like mortgages or auto loans, student loans, or tax debts. During your free consultation, we'll review your specific debts and determine the best approach."
  },
  {
    question: "Can you help with merchant cash advance debt?",
    answer: "Yes! We specialize in merchant cash advance (MCA) relief for businesses. MCAs often have extremely high interest rates and daily payment requirements that drain cash flow. Our business debt specialists negotiate with MCA lenders to restructure payments, reduce balances, and restore your business cash flow."
  },
  {
    question: "Is debt settlement better than bankruptcy?",
    answer: "Debt settlement is often a better option than bankruptcy because it's less damaging to your credit, doesn't require court proceedings, and allows you to avoid the stigma of bankruptcy. However, every situation is unique. During your free consultation, we'll compare all your options and help you make the best decision for your financial future."
  },
  {
    question: "How do I get started?",
    answer: "Getting started is easy! Click the 'Get Free Consultation' button or call us directly. We'll schedule a free, no-obligation consultation with one of our licensed debt specialists. They'll review your financial situation, explain your options, and create a personalized debt relief plan. The entire process takes about 30 minutes."
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about debt settlement and our services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200 hover:border-teal-500 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors duration-200"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Still have questions? We're here to help!
          </p>
          <button
            onClick={() => document.querySelector<HTMLElement>('#vapi-widget-floating-button')?.click()}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Chat with a Specialist Now
          </button>
        </div>
      </div>
    </section>
  );
}
